var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoorWifi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.35498 22.0617C7.35498 22.4973 7.70787 22.8501 8.14341 22.8501M7.35498 22.0617L7.355 9.97485M7.35498 22.0617L7.52028 21.8964M8.14341 22.8501L8.5975 22.8501L8.61266 22.8349H10.6886L10.7038 22.8501H11.1578M8.14341 22.8501L8.3087 22.6848M11.8003 15.9394L11.9187 15.821M11.8003 15.9394V16.0971M11.8003 15.9394H11.8279M11.8003 15.9394H11.6625M11.9187 15.821L11.9463 15.821M11.9187 15.821H11.781M11.8003 16.0971L11.9187 16.2155M11.8003 16.0971L11.8278 16.0971M11.8003 16.0971L11.6626 16.0971M11.9187 16.2155H11.9463M11.9187 16.2155H11.781M7.355 9.97485C7.355 9.53931 7.70779 9.18642 8.1434 9.18642M7.355 9.97485L7.52028 10.1401M8.1434 9.18642L8.59748 9.18642L8.61266 9.20157H10.6886L10.7038 9.18642H11.1578M8.1434 9.18642L8.30872 9.35173M11.1578 22.8501C11.5935 22.8501 11.9463 22.4972 11.9463 22.0616M11.1578 22.8501L10.9925 22.6848M11.1578 9.18642C11.5934 9.18642 11.9463 9.53923 11.9463 9.97484M11.1578 9.18642L10.9925 9.35171M11.9463 22.0616V16.2155M11.9463 22.0616L11.781 21.8964M11.9463 9.97484V15.821M11.9463 9.97484L11.781 10.1401M11.8278 16.0971L11.8279 15.9394M11.8278 16.0971L11.9463 16.2155M11.8279 15.9394L11.9463 15.821M11.6626 16.0971L11.781 16.2155M11.6626 16.0971L11.6625 15.9394M11.781 16.2155L11.781 21.8964M11.781 21.8964C11.781 22.3319 11.4281 22.6848 10.9925 22.6848M10.9925 22.6848L8.3087 22.6848M11.6625 15.9394L11.781 15.821M11.781 15.821L11.781 10.1401M7.52028 10.1401C7.52028 9.70459 7.8731 9.35173 8.30872 9.35173M7.52028 10.1401L7.52028 21.8964M8.30872 9.35173L10.9925 9.35171M8.3087 22.6848C7.87316 22.6848 7.52028 22.332 7.52028 21.8964M10.9925 9.35171C11.4281 9.35171 11.781 9.70452 11.781 10.1401",
    stroke: "url(#hinava_random_uuid_64732527249120815067365795287392491457)",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8525 3.41489V28.6216Z",
    fill: "url(#hinava_random_uuid_317790744466988563518530673070367656895)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4684 30.2375L22.2345 30.2375Z",
    fill: "url(#hinava_random_uuid_114726175914087469386705612822174415869)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8504 28.6216L23.8504 3.41488Z",
    fill: "url(#hinava_random_uuid_180631965252359898796082122598553610001)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2345 1.79897L15.4684 1.79896Z",
    fill: "url(#hinava_random_uuid_104100066092762871042543578229849558299)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4684 30.3756H22.2345Z",
    fill: "url(#hinava_random_uuid_79030451846623126098351582394631053264)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7144 3.41489V28.6216Z",
    fill: "url(#hinava_random_uuid_47889482467483291400260535214582033983)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2345 1.6609L15.4684 1.6609Z",
    fill: "url(#hinava_random_uuid_167005736921387697306198824531351984642)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9885 28.6216V3.41489Z",
    fill: "url(#hinava_random_uuid_279179985587419703533050864871670891060)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.383 3.41491L23.9885 3.41489Z",
    fill: "url(#hinava_random_uuid_260056847364070758147465374609162430940)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2345 1.26645L22.2345 1.6609Z",
    fill: "url(#hinava_random_uuid_36557288846178943388101396312718120187)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2345 30.3756L22.2345 30.77Z",
    fill: "url(#hinava_random_uuid_175963663892278851024433332012606335360)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4684 30.3756V30.77Z",
    fill: "url(#hinava_random_uuid_47063654796564270530928014173817142408)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4684 1.26645L15.4684 1.6609Z",
    fill: "url(#hinava_random_uuid_101943078080219717942202295207649224317)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.32 3.41489L13.7144 3.41489Z",
    fill: "url(#hinava_random_uuid_194771814294272961808713858291713098818)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.383 3.41491L24.383 28.6216Z",
    fill: "url(#hinava_random_uuid_330633736345319108734153957387577154881)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9885 28.6216L24.383 28.6216Z",
    fill: "url(#hinava_random_uuid_227086791127701118198230251835072971658)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7144 28.6216H13.32Z",
    fill: "url(#hinava_random_uuid_32464430683751956983139910447931828214)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4684 1.26645L22.2345 1.26645Z",
    fill: "url(#hinava_random_uuid_244040326453010763145603737911156262838)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0557 3.19861V15.821Z",
    fill: "url(#hinava_random_uuid_198166645610693599693797273625141759539)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13.201 15.9393H13.1741Z",
    fill: "url(#hinava_random_uuid_305420835986922434426772728470815665354)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1741 15.9393L13.0557 15.821Z",
    fill: "url(#hinava_random_uuid_157938593899134858836951880715946112258)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1741 16.0971H13.201Z",
    fill: "url(#hinava_random_uuid_24149053861927548790290864961096755395)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1741 15.9393L13.1741 16.0971Z",
    fill: "url(#hinava_random_uuid_269835923848580926444369453832475210681)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0826 16.2155H13.0557Z",
    fill: "url(#hinava_random_uuid_308866334776087145603921276980246426508)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0557 16.2155L13.1741 16.0971Z",
    fill: "url(#hinava_random_uuid_202378318967339953702028194551467050567)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0557 16.2155L13.0557 28.8379Z",
    fill: "url(#hinava_random_uuid_263525533818280983603752468462711856721)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6485 3.19857H24.6209Z",
    fill: "url(#hinava_random_uuid_256573513766750429394796642948808378577)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6485 28.8379L24.6485 3.19857Z",
    fill: "url(#hinava_random_uuid_54902706243618491967218449028014686266)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6485 28.8379H24.6209Z",
    fill: "url(#hinava_random_uuid_25055221696859658240678276573545966174)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2511 31.0334H22.4499Z",
    fill: "url(#hinava_random_uuid_258567838225659642068008436151979064296)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2521 1V1.02754Z",
    fill: "url(#hinava_random_uuid_217370896782531375687980117099521364859)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4508 1L15.2521 1Z",
    fill: "url(#hinava_random_uuid_8191272158689400670604735093846086861)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4508 1V1.02754Z",
    fill: "url(#hinava_random_uuid_270135287887290284363686190647480925492)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4499 31.0334C22.7378 31.0338 23.0253 30.977 23.2912 30.8672C23.557 30.7575 23.801 30.5948 24.0045 30.3916C24.208 30.1884 24.371 29.9447 24.4811 29.679C24.5913 29.4132 24.6485 29.1257 24.6485 28.8379",
    fill: "url(#hinava_random_uuid_137972186473675247933206425704953619733)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2521 1C14.9642 0.999847 14.6766 1.057 14.4107 1.16708C14.1449 1.27716 13.9011 1.44016 13.6978 1.64362C13.4945 1.84716 13.3317 2.09108 13.222 2.35708C13.1121 2.623 13.0553 2.91069 13.0557 3.19861",
    fill: "url(#hinava_random_uuid_268770015375678356120264390378017715477)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6485 3.19857C24.6488 2.91057 24.592 2.6228 24.4821 2.3568C24.3722 2.09073 24.2094 1.84673 24.0059 1.64319C23.8025 1.43965 23.5585 1.27673 23.2925 1.16673C23.0266 1.05673 22.7388 0.999694 22.4508 1",
    fill: "url(#hinava_random_uuid_244266135084128798270250350016634667191)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0557 28.8379C13.0557 29.1255 13.1128 29.4127 13.2227 29.6783C13.3327 29.9438 13.4954 30.1873 13.6985 30.3905C13.9017 30.5937 14.1453 30.7564 14.4107 30.8663C14.6763 30.9763 14.9636 31.0334 15.2511 31.0334",
    fill: "url(#hinava_random_uuid_99482404784640588160403827597723132460)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3003 15.821L13.4185 15.9392Z",
    fill: "url(#hinava_random_uuid_315170659644956970375984402227747002377)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4185 15.9392L13.201 15.9393Z",
    fill: "url(#hinava_random_uuid_132399762318269348885878674028557214187)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M13.201 15.9393L13.0826 15.821Z",
    fill: "url(#hinava_random_uuid_6998095127014562723383502501629453708)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2345 1.24673L22.4521 1.02911Z",
    fill: "url(#hinava_random_uuid_196020412065356266137640572821477849158)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6203 3.19725L24.4027 3.41486Z",
    fill: "url(#hinava_random_uuid_257901385019495226478142802395172340369)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4684 30.7897L15.2508 31.0074Z",
    fill: "url(#hinava_random_uuid_23570356027800863427695133882186441466)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0826 28.8392L13.3002 28.6216Z",
    fill: "url(#hinava_random_uuid_144724175357265002684167821950690508318)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3003 3.41489L13.0826 3.19727Z",
    fill: "url(#hinava_random_uuid_245634796256772576453687832620996603818)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2508 1.02909L15.4684 1.2467Z",
    fill: "url(#hinava_random_uuid_305512753679040850396435219520530125827)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M13.201 16.0971H13.4185Z",
    fill: "url(#hinava_random_uuid_228863488994317036104604612948079929869)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4027 28.6216L24.6203 28.8392Z",
    fill: "url(#hinava_random_uuid_285816886663512155171492345110522142005)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4522 31.0074L22.2345 30.7898Z",
    fill: "url(#hinava_random_uuid_35559166749900895738005403297084226017)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3003 3.41489V15.821Z",
    fill: "url(#hinava_random_uuid_71791436082963476992539128700813617899)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4684 30.7897L22.2345 30.7898Z",
    fill: "url(#hinava_random_uuid_129774866826257528089430332037868628540)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3003 16.2155L13.3002 28.6216Z",
    fill: "url(#hinava_random_uuid_128741323322013197553463294172199002482)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4185 16.0971L13.3003 16.2155Z",
    fill: "url(#hinava_random_uuid_294789733315166704027670512736633814656)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0826 16.2155H13.3003Z",
    fill: "url(#hinava_random_uuid_52934693717775306320245254179884547397)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0826 16.2155L13.201 16.0971Z",
    fill: "url(#hinava_random_uuid_123099590849295426047793787688510655479)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4185 15.9392V16.0971Z",
    fill: "url(#hinava_random_uuid_147612075101709134166753346666427165343)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4684 1.6609L22.2345 1.6609L22.2345 1.26645L15.4684 1.26645L15.4684 1.6609Z",
    fill: "url(#hinava_random_uuid_138067293167115789791218063423108568146)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0557 3.19861V15.821H13.3003L13.4185 15.9392V16.0971L13.3003 16.2155H13.0826H13.0557L13.0557 28.8379C13.0557 29.1255 13.1128 29.4127 13.2227 29.6783C13.3327 29.9438 13.4954 30.1873 13.6985 30.3905C13.9017 30.5937 14.1453 30.7564 14.4107 30.8663C14.6763 30.9763 14.9636 31.0334 15.2511 31.0334H22.4499C22.7378 31.0338 23.0253 30.977 23.2912 30.8672C23.557 30.7575 23.801 30.5948 24.0045 30.3916C24.208 30.1884 24.371 29.9447 24.4811 29.679C24.5913 29.4132 24.6485 29.1257 24.6485 28.8379L24.6485 3.19857C24.6488 2.91057 24.592 2.6228 24.4821 2.3568C24.3722 2.09073 24.2094 1.84673 24.0059 1.64319C23.8025 1.43965 23.5585 1.27673 23.2925 1.16673C23.0266 1.05673 22.7388 0.999694 22.4508 1L15.2521 1C14.9642 0.999847 14.6766 1.057 14.4107 1.16708C14.1449 1.27716 13.9011 1.44016 13.6978 1.64362C13.4945 1.84716 13.3317 2.09108 13.222 2.35708C13.1121 2.623 13.0553 2.91069 13.0557 3.19861ZM22.2345 30.3756H15.4684L15.4663 30.3754C15.3517 30.3689 15.2371 30.3623 15.1247 30.3416C15.0121 30.3209 14.9017 30.286 14.7957 30.2416C14.6896 30.197 14.5878 30.1429 14.4924 30.0791C14.3973 30.0156 14.3084 29.9425 14.2275 29.8615C14.1462 29.7801 14.0728 29.6907 14.0091 29.595C13.9458 29.4999 13.8921 29.3985 13.8478 29.2928C13.8034 29.1866 13.7686 29.076 13.748 28.9633C13.7276 28.8515 13.721 28.7375 13.7145 28.6235L13.7144 28.6216V3.41489L13.7146 3.4127C13.7211 3.29812 13.7277 3.18357 13.7484 3.07121C13.7691 2.9586 13.804 2.84821 13.8484 2.74213C13.893 2.63606 13.9471 2.53429 14.0109 2.43883C14.0744 2.34375 14.1475 2.2549 14.2285 2.17398C14.3099 2.09267 14.3993 2.01929 14.495 1.9556C14.5901 1.89229 14.6915 1.83852 14.7972 1.79429C14.9034 1.74983 15.014 1.71513 15.1267 1.69444C15.2385 1.67402 15.3525 1.66752 15.4665 1.66102L15.4684 1.6609L15.4684 1.26645L22.2345 1.26645L22.2364 1.26655C22.377 1.2746 22.5176 1.28264 22.6555 1.30806C22.7934 1.33345 22.9286 1.37614 23.0585 1.4306C23.1884 1.48514 23.3131 1.55145 23.43 1.62953C23.5464 1.70737 23.6553 1.79691 23.7544 1.89606C23.8541 1.99583 23.9439 2.1053 24.0219 2.22253C24.0995 2.33906 24.1654 2.46322 24.2195 2.59268C24.274 2.72276 24.3165 2.85822 24.3418 2.9963C24.367 3.13349 24.3749 3.27328 24.3829 3.41315L24.383 3.41491L24.383 28.6216L23.9885 28.6216L23.9884 28.6237C23.9818 28.7383 23.9752 28.8529 23.9545 28.9653C23.9338 29.0779 23.899 29.1883 23.8545 29.2943C23.81 29.4004 23.7558 29.5022 23.6921 29.5976C23.6285 29.6927 23.5554 29.7816 23.4744 29.8625C23.3931 29.9438 23.3037 30.0172 23.208 30.0809C23.1128 30.1442 23.0114 30.198 22.9058 30.2422C22.7995 30.2866 22.689 30.3214 22.5762 30.342C22.4645 30.3624 22.3504 30.369 22.2364 30.3755L22.2345 30.3756Z",
    fill: "url(#hinava_random_uuid_242988459418149317001632110800112373347)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9884 3.41298L23.9885 3.41489L24.383 3.41491L24.3829 3.41315C24.3749 3.27328 24.367 3.13349 24.3418 2.9963C24.3165 2.85822 24.274 2.72276 24.2195 2.59268C24.1654 2.46322 24.0995 2.33906 24.0219 2.22253C23.9439 2.1053 23.8541 1.99583 23.7544 1.89606C23.6553 1.79691 23.5464 1.70737 23.43 1.62953C23.3131 1.55145 23.1884 1.48514 23.0585 1.4306C22.9286 1.37614 22.7934 1.33345 22.6555 1.30806C22.5176 1.28264 22.377 1.2746 22.2364 1.26655L22.2345 1.26645L22.2345 1.6609L22.2367 1.66103C22.3513 1.6676 22.4658 1.67417 22.5782 1.69489C22.6149 1.70164 22.6514 1.70989 22.6876 1.71948C22.7623 1.73932 22.8358 1.76492 22.9073 1.79489C23.0133 1.83943 23.1151 1.89358 23.2106 1.95735C23.3057 2.02089 23.3945 2.09397 23.4754 2.17497C23.5567 2.25635 23.6301 2.34574 23.6938 2.44143C23.7571 2.53658 23.8109 2.63797 23.8551 2.74366C23.8848 2.81469 23.9102 2.88764 23.93 2.9619C23.9397 2.9987 23.9481 3.03583 23.955 3.0732C23.9754 3.18496 23.9819 3.299 23.9884 3.41298Z",
    fill: "url(#hinava_random_uuid_136915074165748732629265844503927712182)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9885 3.41489V28.6216L24.383 28.6216L24.383 3.41491L23.9885 3.41489Z",
    fill: "url(#hinava_random_uuid_225740573219757131698856907115583433370)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3195 1.80978C15.2897 1.81244 15.2599 1.81554 15.2302 1.81933Z",
    fill: "url(#hinava_random_uuid_83710822913894502576913216018938186871)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2364 1.26655L22.2345 1.26645L22.6876 1.71948C22.7623 1.73932 22.8358 1.76492 22.9073 1.79489C23.0133 1.83943 23.1151 1.89358 23.2106 1.95735C23.3057 2.02089 23.3945 2.09397 23.4754 2.17497C23.5567 2.25635 23.6301 2.34574 23.6938 2.44143C23.7571 2.53658 23.8109 2.63797 23.8551 2.74366C23.8848 2.81469 23.9102 2.88764 23.93 2.9619L24.383 3.41491L24.3829 3.41315C24.3749 3.27328 24.367 3.13349 24.3418 2.9963C24.3165 2.85822 24.274 2.72276 24.2195 2.59268C24.1654 2.46322 24.0995 2.33906 24.0219 2.22253C23.9439 2.1053 23.8541 1.99583 23.7544 1.89606C23.6553 1.79691 23.5464 1.70737 23.43 1.62953C23.3131 1.55145 23.1884 1.48514 23.0585 1.4306C22.9286 1.37614 22.7934 1.33345 22.6555 1.30806C22.5176 1.28264 22.377 1.2746 22.2364 1.26655Z",
    fill: "url(#hinava_random_uuid_10420918205517903846790073164400554722)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4185 16.0971H13.201L13.0826 16.2155H13.3003L13.4185 16.0971Z",
    fill: "url(#hinava_random_uuid_36471673827682044314500235616644097977)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M13.201 15.9393H13.1741L13.1741 16.0971H13.201H13.4185V15.9392L13.201 15.9393Z",
    fill: "url(#hinava_random_uuid_257590117366216539246839590541386360426)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1741 15.9393H13.201L13.4185 15.9392L13.3003 15.821H13.0557L13.1741 15.9393Z",
    fill: "url(#hinava_random_uuid_85557960737839850784873798534066521683)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M13.201 16.0971H13.1741L13.0557 16.2155H13.0826L13.201 16.0971Z",
    fill: "url(#hinava_random_uuid_192875424433131974431308998996307359855)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4075 19.9645C15.4224 19.9351 15.4456 19.9108 15.4744 19.8948C15.6463 19.8746 15.8197 19.8699 15.9924 19.8805C16.3254 19.8805 16.5019 19.8805 16.5261 19.8805C16.5478 19.8852 16.568 19.8954 16.5847 19.9101C16.6014 19.9249 16.6139 19.9437 16.6212 19.9647C16.6285 19.9857 16.6303 20.0083 16.6263 20.0302C16.6224 20.0521 16.6128 20.0726 16.5986 20.0897C16.556 20.1381 16.5545 20.1381 16.3396 20.141H16.1475V20.9948H16.3382C16.5133 20.9948 16.5318 20.9948 16.556 21.0076C16.5788 21.0173 16.5981 21.0339 16.6111 21.0551C16.6241 21.0763 16.6302 21.101 16.6285 21.1257C16.6295 21.1534 16.6209 21.1806 16.6044 21.2029C16.5878 21.2251 16.5642 21.2411 16.5375 21.2481C16.5204 21.2481 16.351 21.2553 15.9995 21.2481H15.4886L15.4616 21.2311C15.447 21.2221 15.4344 21.2103 15.4245 21.1963C15.4145 21.1824 15.4074 21.1667 15.4036 21.15C15.3997 21.1333 15.3992 21.1161 15.4021 21.0992C15.405 21.0823 15.4112 21.0662 15.4203 21.0517C15.4587 20.992 15.4687 20.9906 15.6893 20.9906H15.88V20.1367H15.6879C15.5 20.1367 15.4943 20.1367 15.4687 20.1182C15.4494 20.1076 15.4331 20.0922 15.4214 20.0735C15.4097 20.0548 15.403 20.0335 15.4018 20.0115C15.4018 19.9956 15.4037 19.9799 15.4075 19.9645Z",
    fill: "url(#hinava_random_uuid_222650174676513791539815381818287444569)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4118 21.5698C15.4269 21.539 15.4527 21.5147 15.4844 21.5014C15.5014 21.5014 15.6879 21.5014 16.0337 21.5014H16.5574L16.5844 21.5299C16.601 21.5439 16.6136 21.5621 16.6209 21.5827C16.6281 21.6032 16.6298 21.6252 16.6257 21.6466C16.626 21.6601 16.6229 21.6734 16.6167 21.6853C16.6105 21.6973 16.6013 21.7075 16.5901 21.7149C16.5732 21.7309 16.5534 21.7434 16.5318 21.7519C16.4948 21.7619 15.5356 21.7619 15.4972 21.7519C15.4782 21.7461 15.4608 21.7363 15.4458 21.7234C15.4309 21.7104 15.4188 21.6944 15.4104 21.6765C15.4031 21.6596 15.3995 21.6414 15.3997 21.623C15.3999 21.6046 15.4041 21.5865 15.4118 21.5698Z",
    fill: "url(#hinava_random_uuid_257701255805349242048928572248172084954)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4104 22.0493C15.4236 22.0239 15.4432 22.0023 15.4673 21.9867C15.6383 21.9671 15.8107 21.9633 15.9824 21.9753C16.1561 21.9676 16.3301 21.9709 16.5033 21.9853C16.5272 21.9964 16.549 22.0119 16.5673 22.0308C16.5895 22.0505 16.6066 22.0753 16.617 22.1031C16.6274 22.1309 16.6309 22.1608 16.6271 22.1902C16.6271 22.2557 16.6043 22.2827 16.5147 22.3695L16.3496 22.5275L16.1063 22.7623L15.8558 23.0014L15.7562 23.0967H16.1475C16.2857 23.0875 16.4244 23.0923 16.5616 23.111C16.5796 23.1214 16.5948 23.1358 16.6062 23.1531C16.6176 23.1704 16.6248 23.1901 16.6273 23.2106C16.6298 23.2312 16.6274 23.252 16.6205 23.2715C16.6136 23.291 16.6022 23.3087 16.5873 23.323C16.5763 23.3343 16.5632 23.3435 16.5488 23.3501C16.5346 23.3501 16.3667 23.3501 16.0351 23.3501C15.4815 23.3501 15.5142 23.3501 15.4573 23.2988C15.4384 23.2822 15.4231 23.2619 15.4124 23.2391C15.4016 23.2164 15.3956 23.1916 15.3947 23.1665C15.3947 23.0953 15.4118 23.0512 15.4943 22.9715C15.5769 22.8918 15.8771 22.6029 15.9042 22.5787L16.1788 22.324L16.2685 22.2372H15.4986L15.4659 22.2215C15.4452 22.2108 15.4278 22.1947 15.4156 22.1749C15.4033 22.1551 15.3966 22.1324 15.3961 22.1091C15.3956 22.0883 15.4005 22.0677 15.4104 22.0493Z",
    fill: "url(#hinava_random_uuid_269738456122167271384860335029663155981)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4175 23.8368C15.4422 23.756 15.4938 23.686 15.5637 23.6385C15.6335 23.5909 15.7175 23.5686 15.8018 23.5753C15.886 23.5819 15.9655 23.6171 16.0271 23.6749C16.0886 23.7328 16.1286 23.81 16.1404 23.8937C16.1489 23.9577 16.1489 24.6678 16.1404 24.7034C16.1272 24.7404 16.1009 24.7713 16.0664 24.7902C16.0471 24.7982 16.026 24.8011 16.0052 24.7988C15.9832 24.7975 15.9619 24.7907 15.9433 24.779C15.9246 24.7673 15.9092 24.7511 15.8985 24.7319L15.8814 24.7048V24.3021C15.8814 23.8467 15.8814 23.8752 15.8202 23.8453C15.8022 23.8363 15.7821 23.8328 15.7621 23.835C15.7421 23.8373 15.7233 23.8453 15.7078 23.8581C15.6608 23.8937 15.6622 23.8809 15.6637 24.3363V24.7475L15.6807 24.7888C15.6986 24.8365 15.7262 24.88 15.7617 24.9164C15.7972 24.9529 15.8399 24.9817 15.8871 25.0009C15.9266 25.0175 15.9696 25.0243 16.0123 25.0208C16.0546 25.0245 16.0972 25.0176 16.1361 25.0009C16.1857 24.9824 16.2306 24.9532 16.2675 24.9153C16.3044 24.8774 16.3325 24.8318 16.3496 24.7817C16.3692 24.6107 16.3744 24.4384 16.3653 24.2665C16.3653 23.7272 16.3653 23.7613 16.4236 23.7201C16.4342 23.7113 16.4465 23.7049 16.4598 23.7012C16.473 23.6976 16.4869 23.6967 16.5005 23.6987C16.5474 23.6987 16.5503 23.6987 16.5801 23.7272C16.5958 23.7408 16.6088 23.7572 16.6186 23.7756C16.6276 23.9476 16.6276 24.1201 16.6186 24.2921V24.7888L16.5958 24.8557C16.561 24.959 16.5003 25.0516 16.4193 25.1247C16.4007 25.1428 16.3807 25.1594 16.3596 25.1745C16.3489 25.1778 16.3391 25.1837 16.3311 25.1915C16.2767 25.2247 16.2177 25.2497 16.1561 25.2656C16.0602 25.2891 15.9602 25.2891 15.8643 25.2656C15.7534 25.2369 15.6525 25.1785 15.5722 25.0968C15.492 25.0151 15.4355 24.913 15.4089 24.8016C15.3874 24.6389 15.3827 24.4744 15.3947 24.3106C15.4004 23.8951 15.4004 23.8923 15.4175 23.8368Z",
    fill: "url(#hinava_random_uuid_317576113916167224455487122479995206235)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4061 26.034C15.4206 25.9891 15.446 25.9485 15.4801 25.9159C15.5114 25.8903 15.7775 25.7366 16.0493 25.5914C16.0778 25.5758 16.1418 25.5416 16.1916 25.5132C16.4222 25.3837 16.4649 25.3709 16.4976 25.3709C16.5301 25.371 16.5615 25.3832 16.5856 25.4049C16.6098 25.4267 16.625 25.4566 16.6285 25.489C16.6285 25.5616 16.6043 25.6 16.499 25.6555C16.3439 25.738 15.6964 26.0952 15.6893 26.1023C15.6822 26.1094 15.6978 26.1151 15.7135 26.1237C15.7291 26.1322 15.7619 26.1493 15.7832 26.1621L15.8672 26.2091C15.9824 26.2703 16.2201 26.4012 16.3254 26.461C16.3909 26.4965 16.4677 26.5406 16.5061 26.5591C16.6043 26.6118 16.63 26.6417 16.63 26.7086C16.6304 26.7289 16.6258 26.749 16.6166 26.7671C16.6074 26.7852 16.5939 26.8008 16.5773 26.8125C16.5531 26.8324 16.546 26.8352 16.5005 26.8352H16.4492L16.3254 26.7669C16.2187 26.7057 15.9511 26.5577 15.8017 26.4823L15.7306 26.4439L15.6025 26.3727C15.5911 26.3656 15.5655 26.3528 15.5456 26.3414C15.4938 26.3131 15.4517 26.27 15.4246 26.2176C15.41 26.188 15.4027 26.1553 15.4032 26.1223C15.4011 26.0928 15.4021 26.0633 15.4061 26.034Z",
    fill: "url(#hinava_random_uuid_270192818483329252086627981010918468107)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4104 27.1882C15.4392 27.092 15.5025 27.0099 15.5882 26.9576C15.6416 26.9278 15.7014 26.9115 15.7624 26.9102C15.8235 26.9088 15.8839 26.9224 15.9385 26.9498C15.9931 26.9771 16.0402 27.0174 16.0756 27.0672C16.1111 27.1169 16.1338 27.1746 16.1418 27.2351C16.1418 27.2707 16.1418 27.4429 16.1418 27.672V28.0506L16.1205 28.0776C16.1064 28.0945 16.0895 28.1089 16.0707 28.1203C16.0531 28.1295 16.0337 28.1346 16.0139 28.1351C15.9941 28.1357 15.9745 28.1317 15.9565 28.1234C15.9385 28.1152 15.9226 28.1029 15.9101 28.0875C15.8976 28.0722 15.8887 28.0542 15.8842 28.0349C15.8842 28.015 15.8771 27.8784 15.8771 27.625V27.2422L15.8615 27.218C15.8508 27.2026 15.8363 27.1901 15.8195 27.1818C15.8027 27.1734 15.784 27.1695 15.7652 27.1704C15.7464 27.1712 15.7282 27.1768 15.7122 27.1867C15.6961 27.1965 15.6829 27.2102 15.6736 27.2266C15.658 27.2522 15.658 27.2593 15.658 27.6535C15.658 28.0804 15.658 28.0804 15.6921 28.1573C15.7301 28.2381 15.7972 28.3017 15.88 28.3352C15.9245 28.3553 15.9736 28.3637 16.0223 28.3594C16.0855 28.3588 16.1474 28.3409 16.2013 28.3079C16.2552 28.2748 16.2991 28.2276 16.3283 28.1715C16.3681 28.0961 16.3681 28.0918 16.3681 27.6023C16.3681 27.1753 16.3681 27.1455 16.3823 27.1184C16.3911 27.0964 16.4059 27.0773 16.4249 27.0632C16.4439 27.0491 16.4665 27.0405 16.4901 27.0385C16.5137 27.0364 16.5374 27.0409 16.5585 27.0515C16.5797 27.0621 16.5975 27.0784 16.61 27.0985L16.6257 27.1184V28.1345L16.6058 28.1914C16.5542 28.3484 16.4441 28.4794 16.2984 28.5572C16.2199 28.6004 16.1318 28.623 16.0422 28.6226C15.9888 28.628 15.9349 28.6242 15.8828 28.6113C15.84 28.6005 15.7981 28.5862 15.7576 28.5686C15.7109 28.5485 15.6677 28.5211 15.6295 28.4874C15.5291 28.4054 15.4562 28.2947 15.4203 28.1701C15.4061 28.1231 15.4061 28.1018 15.4047 27.6763C15.397 27.5136 15.3989 27.3506 15.4104 27.1882Z",
    fill: "url(#hinava_random_uuid_173871410750132013481935486114794998804)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_64732527249120815067365795287392491457",
    x1: 9.65062,
    y1: 9.18642,
    x2: 9.65062,
    y2: 22.8501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_317790744466988563518530673070367656895",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_114726175914087469386705612822174415869",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_180631965252359898796082122598553610001",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_104100066092762871042543578229849558299",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_79030451846623126098351582394631053264",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_47889482467483291400260535214582033983",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_167005736921387697306198824531351984642",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_279179985587419703533050864871670891060",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_260056847364070758147465374609162430940",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_36557288846178943388101396312718120187",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_175963663892278851024433332012606335360",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_47063654796564270530928014173817142408",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_101943078080219717942202295207649224317",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_194771814294272961808713858291713098818",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_330633736345319108734153957387577154881",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_227086791127701118198230251835072971658",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_32464430683751956983139910447931828214",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_244040326453010763145603737911156262838",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_198166645610693599693797273625141759539",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_305420835986922434426772728470815665354",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_157938593899134858836951880715946112258",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_24149053861927548790290864961096755395",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_269835923848580926444369453832475210681",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_308866334776087145603921276980246426508",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_202378318967339953702028194551467050567",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_263525533818280983603752468462711856721",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_256573513766750429394796642948808378577",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_54902706243618491967218449028014686266",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_25055221696859658240678276573545966174",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_258567838225659642068008436151979064296",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_217370896782531375687980117099521364859",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_8191272158689400670604735093846086861",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_270135287887290284363686190647480925492",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_137972186473675247933206425704953619733",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_268770015375678356120264390378017715477",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_244266135084128798270250350016634667191",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_99482404784640588160403827597723132460",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_315170659644956970375984402227747002377",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_132399762318269348885878674028557214187",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_6998095127014562723383502501629453708",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_196020412065356266137640572821477849158",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_257901385019495226478142802395172340369",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_23570356027800863427695133882186441466",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_144724175357265002684167821950690508318",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_245634796256772576453687832620996603818",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_305512753679040850396435219520530125827",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_228863488994317036104604612948079929869",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_285816886663512155171492345110522142005",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_35559166749900895738005403297084226017",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_71791436082963476992539128700813617899",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_129774866826257528089430332037868628540",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_128741323322013197553463294172199002482",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_294789733315166704027670512736633814656",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_52934693717775306320245254179884547397",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_123099590849295426047793787688510655479",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_147612075101709134166753346666427165343",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_138067293167115789791218063423108568146",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_242988459418149317001632110800112373347",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_136915074165748732629265844503927712182",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_225740573219757131698856907115583433370",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_83710822913894502576913216018938186871",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_10420918205517903846790073164400554722",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_36471673827682044314500235616644097977",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_257590117366216539246839590541386360426",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_85557960737839850784873798534066521683",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_192875424433131974431308998996307359855",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_222650174676513791539815381818287444569",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_257701255805349242048928572248172084954",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_269738456122167271384860335029663155981",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_317576113916167224455487122479995206235",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_270192818483329252086627981010918468107",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_173871410750132013481935486114794998804",
    x1: 18.8521,
    y1: 1,
    x2: 18.8521,
    y2: 31.0334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorWifi);
export default __webpack_public_path__ + "static/media/door-wifi.725e889869230b51bd53daca7d8af132.svg";
export { ForwardRef as ReactComponent };